import React, { FC } from 'react'
import { Link as RouteLink } from 'react-router-dom'
import { Typography } from '@mui/material'
import { Formik } from 'formik'
import { routes } from 'config'
import { IFormProps, isMultiLoginApp } from 'utils'
import {
  Module,
  ModuleHeader,
  ModuleBody,
  CustomAlert,
  CustomTextField,
  CustomButton,
  ButtonContainer,
} from 'components'

const ForgotPasswordForm: FC<IFormProps> = ({
  initialValues,
  validationSchema,
  handleSubmit,
  serviceError,
}) => {
  const forgotPasswordText = isMultiLoginApp()
    ? 'Enter your Multi Login Name and we will email you instructions to reset your password.'
    : 'Enter your Login Name and we will email you instructions to reset your password.'

  const labelForgotPassword = isMultiLoginApp()
    ? 'Multi Login Name'
    : 'Login Name'

  return (
    <Module>
      <ModuleHeader title="Recover Your Password">
        <Typography variant="body1">{forgotPasswordText}</Typography>
        <CustomAlert severity="error">{serviceError}</CustomAlert>
      </ModuleHeader>

      <ModuleBody>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            handleSubmit: onSubmit,
            dirty,
            isValid,
            isSubmitting,
            getFieldProps,
            getFieldMeta,
            setFieldTouched,
            setFieldError,
            touched,
            errors,
            values,
          }) => (
            <form onSubmit={onSubmit}>
              <CustomTextField
                autoFocus
                id="username"
                label={labelForgotPassword}
                hasServiceError={Boolean(serviceError)}
                touched={touched}
                errors={errors}
                values={values}
                getFieldMeta={getFieldMeta}
                setFieldTouched={setFieldTouched}
                setFieldError={setFieldError}
                {...getFieldProps('username')}
              />

              <ButtonContainer
                primary={
                  <CustomButton
                    type="submit"
                    disabled={!dirty || !isValid || isSubmitting}
                  >
                    Reset Password
                  </CustomButton>
                }
                secondary={
                  isMultiLoginApp() ? (
                    <RouteLink to={routes.multiLogin}>
                      Return To Multi Login
                    </RouteLink>
                  ) : (
                    <RouteLink to={routes.login}>Return To Login</RouteLink>
                  )
                }
              />
            </form>
          )}
        </Formik>
      </ModuleBody>
    </Module>
  )
}

export default ForgotPasswordForm
